<script>
import {IconTruck} from '@tabler/icons-vue';
import AssetDashboardCard from "@/Widgets/Cards/AssetDashboardCard.vue";

export default {
  name: "AssetsList",
  components: {
    AssetDashboardCard,
    IconTruck,
  },
  props: {
    value: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
    },
    subtitle: {
      type: String,
    },
    loading: Boolean,
    totalRecords: Number,
    rows: Number,
    first: Number,
  },
  computed: {
    getTitle() {
      return this.title ?? this.$t('common.assets');
    },
    getSubtitle() {
      return this.subtitle ?? this.$t('common.total');
    }
  },
}
</script>

<template>
  <AssetDashboardCard
      :title="getTitle"
      :subtitle="getSubtitle"
      :loading="loading"
      :pt="{
					body: {
						style: {
              'overflow-y': 'hidden',
              'padding-bottom': 0,
            }
					},
					content: {
						style: {
							'overflow-y': 'scroll',
							'border-top': 'solid 1px rgb(203,213,225)',
							'margin-top': '0.75rem',
							'margin-bottom': '-1rem',
						}
					},
					footer: {
            class: ['p-0', 'z-10'],
					}
				}">
    <div class="flex flex-col flex-1 justify-stretch -mx-5 mb-10">
      <DataView :value="value">
        <template #list="slotProps">
          <div class="flex flex-col divide-y divide-surface-200">
            <div v-for="(item, index) in slotProps.items" :key="index"
                 class="flex flex-row items-center first:pt-0 py-2.5 px-3 gap-2.5">
              <div class="h-9 w-9 bg-primary-50 rounded-md inline-flex items-center justify-center">
                <IconTruck class="text-primary-900 opacity-50"/>
              </div>
              <div class="flex-1 flex flex-col justify-start overflow-x-hidden">
                <router-link :to="{name: 'assets.show', params: { asset: item.id }}" class="truncate">
                  <span class="text-sm font-semibold text-surface-600">{{ item.name }}</span>
                </router-link>
                <span class="text-xs font-medium text-surface-400">0.0.00 -> 0.0.00</span>
              </div>
            </div>
          </div>
        </template>
      </DataView>
    </div>

    <template #footer>
      <Paginator
          v-show="!loading"
          :pt="{
            paginatorWrapper: {
            class: ['border-t-0']
            }
          }"
          :rows="rows"
          :first="first"
          :total-records="totalRecords"
          @page="$event => $emit('page', $event)"
          template="FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
      />
    </template>
  </AssetDashboardCard>

</template>

<style scoped>

</style>
